// Keep exact decimal strings intact. Converting inventory money to Number loses precision.
export function formatDecimal(value, fractionDigits = 2) {
  if (value === null || value === undefined || value === "") return null;
  const match = String(value).match(/^(-?)(\d+)(?:\.(\d+))?$/);
  if (!match) return null;
  const [, sign, integer, fractional = ""] = match;
  const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, "\u00a0");
  const exactFraction = fractional.replace(/0+$/, "").padEnd(fractionDigits, "0");
  return `${sign}${grouped}${exactFraction ? `,${exactFraction}` : ""}`;
}

/** True for 0 / 0.00 / 0.0 without using Number(). Missing/invalid values are not zero. */
export function isZeroDecimal(value) {
  if (value === null || value === undefined || value === "") return false;
  const match = String(value).match(/^(-?)(\d+)(?:\.(\d+))?$/);
  if (!match) return false;
  return match[2].replace(/^0+/, "") === "" && !(match[3] || "").replace(/0/g, "");
}

/** Incomplete coverage must not present 0,00 NOK as a valued inbound/opening total. */
export function displayValuationAmount(value, { incomplete = false } = {}) {
  if (formatDecimal(value) === null) return null;
  if (incomplete && isZeroDecimal(value)) return null;
  return value;
}

/** Inventory dates are business dates in Europe/Oslo, independent of browser timezone. */
export function osloToday(date = new Date()) {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "Europe/Oslo", year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(date);
  const value = (name) => parts.find((part) => part.type === name)?.value;
  return `${value("year")}-${value("month")}-${value("day")}`;
}

export function osloMonthPeriod(date = new Date()) {
  const to = osloToday(date);
  return { from: `${to.slice(0, 7)}-01`, to, periodType: "custom" };
}

/** Rails receipt request_key is UUID-shaped; keep retries stable across browser versions. */
export function makeInventoryRequestKey() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  const bytes = new Uint8Array(16);
  if (typeof crypto !== "undefined" && crypto.getRandomValues) crypto.getRandomValues(bytes);
  else for (let index = 0; index < bytes.length; index += 1) bytes[index] = Math.floor(Math.random() * 256);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
